import client from './main-client';

export const sendEmailApi = data => client().post('/custom/sendEmail', data);
